import { Box, Card, CardActions, CardContent, Typography } from "@mui/material";

interface DescriptionComponent {
    customer: any;
}
export const DescriptionComponent = ({ customer }: DescriptionComponent) => {
    return (
        <Box className="recentNotesWrapper">
            <Box className="subHead2">
                <Typography variant="h3" className="primaryColor" style={{ marginBottom: '5px' }}>
                    Description
                </Typography>
            </Box>
            {
                customer?.description && (
                    <Box className="recentNotesContainer" sx={{ pr: 2 }}>
                        <Card elevation={0} sx={{ mb: 1 }}>
                            <CardContent>
                                <Typography variant="body1">{customer?.description}</Typography>
                            </CardContent>
                            {/* <CardActions disableSpacing>
                                <Typography variant="caption" fontStyle={'italic'}>
                                    Created on: <i>{customer?.createdOn}</i>
                                </Typography>
                            </CardActions> */}
                        </Card>
                    </Box>
                )
            }
        </Box>
    );
}